// extracted by mini-css-extract-plugin
export default {"productGrid":"m2-z","centerLink":"n2-z","productSection":"o2-z","item":"p2-z","ctaButton":"q2-z"};